import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row, Col } from "reactstrap";
import {
  getLastScoreCard,
  setCurrentPageScoringLogs,
  setItemsPerPageScoringLogs,
} from "../../actions/getLastScoreCardActions";

import {
  getLastScoreCardSelector,
  getPageInfoScoreCardLogsSelector,
  scoreCardsIsLoadingSelector,
} from "../../selectors";

import ScoreCardsTable from "../../components/score-cards-table";
import PageTitle from "../../../../components/common/PageTitle";
import Pagination from "../../../../components/Pagination/Pagination";
import FullscreenLoader from "../../../../layouts/FullScreenLoader";

const ScoreCardsHistoryPage = () => {
  const { itemsPerPage, currentPage } = useSelector(
    getPageInfoScoreCardLogsSelector
  );
  const isLoading = useSelector(scoreCardsIsLoadingSelector);

  const cards = useSelector(getLastScoreCardSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getLastScoreCard({ page: currentPage, count: itemsPerPage }));
  }, [currentPage, itemsPerPage]);

  // const handlePageClick = ({ selected }) => {
  //   dispatch(getLastScoreCard({ page: selected }));
  // };

  const onPageChange = (_, page) => {
    dispatch(setCurrentPageScoringLogs(page));
  };

  const onRowsPerPageChange = ({ target }) => {
    dispatch(setCurrentPageScoringLogs(0));
    dispatch(setItemsPerPageScoringLogs(target.value));
  };

  return (
    <div>
      <PageTitle title="score card history" />

      <FullscreenLoader loading={isLoading} />
      <Container
        className="score-card-history-container col-12 p-0"
        tabIndex="0"
      >
        {cards != null && cards.data != null && cards.data.length > 0 && (
          <React.Fragment>
            <ScoreCardsTable cards={cards.data} />
            {cards != null && cards.data != null && (
              <Row className="pagination-row mt-5 mb-5 d-flex justify-content-center">
                <Col lg={12} className="d-flex justify-content-center">
                  <Pagination
                    count={cards.elements}
                    page={currentPage}
                    rowsPerPage={itemsPerPage}
                    onPageChange={onPageChange}
                    onRowsPerPageChange={onRowsPerPageChange}
                  />
                </Col>
              </Row>
            )}
          </React.Fragment>
        )}
      </Container>
    </div>
  );
};

export default ScoreCardsHistoryPage;



// WEBPACK FOOTER //
// ./src/features/score-card/pages/score-cards-history-page/ScoreCardsHistoryPage.jsx